/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {Region} from "../model/Region";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class RegionService {

  private readonly regionsUrl: string;

  constructor(private http: HttpClient) {
    this.regionsUrl = inject(APP_CONFIG).baseUrl + '/api/regions';
  }


  getAll(): Observable<Region[]> {
    const url = `${this.regionsUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(regions => regions as Region[]));
  }

  addNew(region: Region): Observable<Region> {
    const url = `${this.regionsUrl}`;
    return this.http.post(url, region, httpOptions).pipe(
      map( region => region as Region ));
  }

  update(region: Region): Observable<Region> {
    var url = `${this.regionsUrl}/${region.regionId}`;
    return this.http.put(url, region, httpOptions).pipe(
      map( region => region as Region ));
  }


}
